export const PRIMARY_COLOR = [
  //DEFAULT
  {
    name: "default",
    main: "#0177FF",
    white: "#ffffff",
    black: "#000000",
    darker: "#0068de",
    color: "#ffffff",
  },

  //WHITE
  {
    name: "white",
    main: "#ffffff",
    white: "#ffffff",
    black: "#000000",
    darker: "#81D3D3",
    color: "#ffffff",
  },
];

export const THEME_COLOR = [
  {
    name: "#FDA92D",
    main: "#FDA92D",
    white: "#ffffff",
    black: "#000000",
    darker: "#FF9800",
    color: "#FDA92D",
  },
  {
    name: "#C0A145",
    main: "#C0A145",
    white: "#ffffff",
    black: "#000000",
    darker: "#C79B18",
    color: "#C0A145",
  },
  {
    name: "#EB0606",
    main: "#EB0606",
    white: "#ffffff",
    black: "#000000",
    darker: "#D90404",
    color: "#EB0606",
  },
  {
    name: "#F53163",
    main: "#F53163",
    white: "#ffffff",
    black: "#000000",
    darker: "#DB1145",
    color: "#F53163",
  },
  {
    name: "#EB00FF",
    main: "#EB00FF",
    white: "#ffffff",
    black: "#000000",
    darker: "#CA08DB",
    color: "#EB00FF",
  },
  {
    name: "#5e2e86",
    main: "#5e2e86",
    white: "#ffffff",
    black: "#000000",
    darker: "#5B09DC",
    color: "#5e2e86",
  },
  {
    name: "#1CCAFF",
    main: "#1CCAFF",
    white: "#ffffff",
    black: "#000000",
    darker: "#07ACDE",
    color: "#1CCAFF",
  },
  {
    name: "#00A3FF",
    main: "#00A3FF",
    white: "#ffffff",
    black: "#000000",
    darker: "#088DD8",
    color: "#00A3FF",
  },
  {
    name: "#00AB55",
    main: "#00AB55",
    white: "#ffffff",
    black: "#000000",
    darker: "#079E52",
    color: "#00AB55",
  },
  {
    name: "#20A2A2",
    main: "#20A2A2",
    white: "#ffffff",
    black: "#000000",
    darker: "#1C9292",
    color: "#20A2A2",
  },
  {
    name: "#0177FF",
    main: "#0177FF",
    white: "#ffffff",
    black: "#000000",
    darker: "#0068de",
    color: "#0177FF",
  },
  {
    name: "#145388",
    main: "#145388",
    white: "#ffffff",
    black: "#000000",
    darker: "#145388",
    color: "#145388",
  },
  // {
  //   name: "#1FA2A2",
  //   main: "#1FA2A2",
  //   white: "#ffffff",
  //   black: "#000000",
  //   darker: "#1FA2A2",
  //   color: "#1FA2A2",
  // },
];
